export default __webpack_public_path__ + "static/media/img.b9b2523a.png";